// custom typefaces
import 'typeface-fira-sans'
import './src/styles/style.scss'
